import React, { FunctionComponent } from 'react';

import Card from '@gojob/ui-bits/Card';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';

import Link from '../Link';
import Image, { ImageProps } from './Image';
import Marks from './Marks';

export type FeatureStoryProps = {
  to: string;
  size?: number;
  publicationDate?: string;
  media?: string;
  ImageProps?: ImageProps;
  className?: string;
  'data-testid'?: string;
  children?: React.ReactNode;
};

const useStyles = () => {
  const { spacing, boxShadow } = useTheme();

  return {
    root: {
      overflow: 'hidden',
      borderRadius: spacing(2),
      textDecoration: 'none',
      ':hover,:focus': {
        outline: 'none',
        boxShadow: boxShadow('shadow', 4),
      },
    },
    imageWrapper: {
      flex: `0 0 auto`,
      width: '100%',
      minHeight: spacing(16),
    },
    content: {
      padding: spacing(2),
      boxSizing: 'border-box',
    },
  } as const;
};

const FeatureStory: FunctionComponent<FeatureStoryProps> = (props) => {
  const { to, children, media, publicationDate, ImageProps, className, 'data-testid': dataTestId } = props;
  const classes = useStyles();

  return (
    <Card
      data-testid={dataTestId}
      as={Link}
      css={classes.root}
      to={to}
      color="white"
      flexDirection="column"
      className={className}
    >
      {ImageProps?.image && (
        <Flex css={classes.imageWrapper}>
          <Image {...ImageProps} />
        </Flex>
      )}

      <Flex flexDirection="column" flex="1 0 auto" alignItems="flex-start" css={classes.content}>
        <Marks media={media} publicationDate={publicationDate} />
        {children}
      </Flex>
    </Card>
  );
};

export default FeatureStory;
